import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getEventMaterials(eventId: number, params: any = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    "events/" + eventId + "/materials?" + parameters
  );
  return data;
}

export async function getEventMaterial(eventId: number, id: number, filters: any) {
  const parameters = objectToParam(filters);
  const { data } = await axios.get(
    "events/" + eventId + "/materials/" + id + "?" + parameters
  );
  return data;
}

export async function createEventMaterial(eventId: number, values: any) {
  const { data } = await axios.post("events/" + eventId + "/materials", values);
  return data;
}

export async function updateEventMaterial(eventId: number, id: number, values: any) {
  const { data } = await axios.patch(
    "events/" + eventId + "/materials/" + id,
    values
  );
  return data;
}

export async function deleteEventMaterial(eventId: number, id: number) {
  const { data } = await axios.delete("events/" + eventId + "/materials/" + id);
  return data;
}
